import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGenerateQR = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/qr/generate`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        }
      );

      const data = await response.json();

      if (response.ok && data.qrCode) {
        localStorage.setItem("generatedQRCode", data.qrCode);
        window.open("/QrPage", "_blank", "noopener,noreferrer");
      } else {
        alert("Failed to generate QR Code");
      }
    } catch (err) {
      console.error("Error generating QR Code:", err);
      alert("An error occurred while generating the QR Code.");
    } finally {
      setLoading(false);
    }
  };
  const handleSignOut = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <>
      <header className="hide_for_confirmation_page">
        <div className="homebanner">
          <img src="homebanner.png" alt="HomePage Banner" />
        </div>
        <div className="homelogo">
          <img src="church_logo_no_bg.png" alt="Church Logo" />
        </div>
        <div className="homebody6">
          <button onClick={handleSignOut}>Sign Out</button>
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Cross Icon" />
        </div>
      </header>
      <header className="hide_for_media_query">
        <div className="media_query_banner media_query_banner1 ">
          <img src="banner_md.png" alt="Media Query Banner" />
          <img
            src="church_logo_no_bg.png"
            alt="Church Avatar No BG"
            className="media_query_logo media_query_logo1"
          />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Church Cross Icon" />
        </div>
      </header>
      <footer>
        <div className="homebody">
          <div className="homebody1">
            <h1>Teacher Control Panel</h1>
          </div>
          <button
            className="homebody2 homebody2_1"
            onClick={handleGenerateQR}
            disabled={loading}
          >
            <div className="homebody3">
              <img src="qr.png" alt="QR Code Icon" />
            </div>
            <div className="homebody4">
              <h5>{loading ? "Generating..." : "Generate QR Code"}</h5>
            </div>
          </button>
          <div className="homebody5">
            <div>
              <button onClick={() => navigate("/ManageAttendance")}>
                View Attendance
              </button>
            </div>
            <div>
              <button onClick={() => navigate("/manageQuestions")}>
                View Question
              </button>
            </div>
            <div>
              <button onClick={() => navigate("/manageStudentPage")}>
                Manage Students
              </button>
            </div>
            <div className="homebody5_signout hide_for_homepage">
              <button onClick={handleSignOut}>Sign Out</button>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default HomePage;
